import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-sm border-b border-sage-100 px-4 md:px-6" data-id="element-65">
      <div className="flex items-center justify-between h-16 max-w-7xl mx-auto" data-id="element-66">
        <div className="flex items-center gap-2" data-id="element-67">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jD76Ad18n41rEXtZp1ThPL/focusflow_logo.png" alt="FocusFlow Logo" className="h-14" data-id="element-68" />
        </div>
        <nav className="hidden md:flex items-center space-x-6" data-id="element-69">
          <a href="#how-it-works" className="text-sm font-medium text-gray-700 hover:text-sage-700" data-id="element-70">
            How It Works
          </a>
          <a href="#benefits" className="text-sm font-medium text-gray-700 hover:text-sage-700" data-id="element-71">
            Benefits
          </a>
          <a href="#testimonials" className="text-sm font-medium text-gray-700 hover:text-sage-700" data-id="element-72">
            Testimonials
          </a>
          <a href="#faq" className="text-sm font-medium text-gray-700 hover:text-sage-700" data-id="element-73">
            FAQ
          </a>
        </nav>
        <a href="https://shop.focusflowblend.com/products/focus-flow-starter-pack" className="px-4 py-2 text-sm font-medium text-white bg-sage-600 rounded-md hover:bg-sage-700" data-id="element-74">
          Get Started
        </a>
      </div>
    </header>;
}